<script setup>
import { object, string } from "yup";
import { Form } from "vee-validate";
import { ProfilePageSchema } from "~/schemas/ProfilePage";

useHead({
  title: "مدیرعامل شرکت نواتل- جناب مهندس حمید فروزنده",
  meta: [
    {
      hid: "description",
      name: "description",
      content:
        "حمید فروزنده مدیر عامل و رئیس هیئت مدیره شرکت شبکه گستران آریاسامانه ( نواتل )، کارآفرین و نوآور در حوزه اینترنت، مخابرات و فناوری اطلاعات است.",
    },
    {
      hid: "keywords",
      name: "keywords",
      content:
        "حمید فروزنده,شبکه گستران آریاسامانه,رئیس هیئت مدیره,مدیر عامل,اپلیکیشن اختصاصی نواتل,مرکز تلفن ابری",
    },
  ],
  link: [
    {
      rel: "canonical",
      href: "https://navatel.ir/managers/",
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify(ProfilePageSchema)
    },
  ],
});

const { validateFaChar, validateMobile } = useInputHelpers();
const { post, loading } = useSendMail();
const isSuccessModalShow = ref(false);

const initialValues = {
  name: "",
  number: "",
  text: "",
};
const schema = object({
  name: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  number: string()
    .required("این فیلد نباید خالی باشد.")
    .test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  text: string().required("این فیلد نباید خالی باشد."),
});

const handleSubmit = async (form, { resetForm }) => {
  if (!loading.value) {
    const { data, error } = await post({
      body: { model: form },
    });

    if (!error.value && data.value === "ok") {
      resetForm();
      isSuccessModalShow.value = true;
    }
  }
};

const closeModal = () => {
  isSuccessModalShow.value = false;
};

const topCardDetails = {
  desc: "حمید فروزنده مدیر عامل و رئیس هیئت مدیره شرکت شبکه گستران آریاسامانه (نواتل)، کارآفرین و نوآور در حوزه اینترنت، مخابرات و فناوری اطلاعات، فارغ التحصیل کارشناسی در رشته مهندسی نرم افزار از دانشگاه شهید بهشتی و کارشناسی ارشد مدیریت کسب و کار از دانشگاه منچستر است. وی با بیش از بیست و شش سال سابقه فعالیت و معرفی محصولات نوآورانه، مرکز تلفن ابری و مرکز تماس ابری نواتل را به عنوان محصولات دانش بنیان به بازار معرفی کرده‌است. فروزنده تمرکز بر کیفیت تجربه مشتریان، یادگیری، بهبود مستمر و چابکی را راهبرد اصلی فرهنگ سازمانی نواتل قرار داده‌است. هم اکنون نواتل با بیش از صد نیروی متخصص به عنوان تنها شرکت ارائه کننده خدمات مرکز تلفن ابری و مرکز تماس ابری با اپلیکیشن اختصاصی، سهم بالایی از بازار داخلی را در اختیار دارد.",
  img: "/img/managers/main.png",
  title: "حمید فروزنده، مدیر عامل و رئیس هیئت مدیره"
};

const moreInfoData = {
  id: "1",
  title: "اخبار و گفتگو‌ها",
  items: [
    {
      id: "1",
      text: "مرکز تلفن ابری و مرکز تماس ابری نواتل، تنها مراکز ابریِ دارای اپلیکیشن اختصاصی",
      img: "/img/managers/1.png",
      url: `https://www.aparat.com/v/fP483`,
    },
    {
      id: "2",
      text: "نواتل در صدا و سیما",
      img: "/img/managers/2.png",
      url: `https://www.aparat.com/v/XoCdu`,
    },
    {
      id: "1",
      text: "حضور نواتل در بیست و چهارمین نمایشگاه بین المللی تلکام",
      img: "/img/managers/3.png",
      url: `https://www.aparat.com/v/Ssbyd`,
    },
  ],
  boxClass: "lg:!w-[32%] !rounded-none",
  imgClass: "lg:!w-full",
};
</script>

<template>
  <div>
      <div
        class="gridClass relative mt-8 bg-cover bg-center bg-no-repeat h-96 rounded-[10px] bg-[url('/img/managers/bg-mobile.png')] lg:bg-[url('/img/managers/bg.png')]"
      >
        <div class="absolute bottom-1/2 select-none w-full">
          <div class="flex items-center">
            <div class="flex-grow border-t border-blue-600"></div>
            <h2 class="mx-4 text-blue-800">
              مدیر عامل و معاونین
            </h2>
            <div class="flex-grow border-t border-blue-600"></div>
          </div>
        </div>
      </div>
      <ProductTopCard :details="topCardDetails" class="mt-10" />
      <section class="gridClass my-10">
        <h2 class="mb-2">ارتباط با مدیر عامل</h2>
        <p class="pb-4 text-body1-bold">
          جهت ارتباط با مدیر عامل شرکت شبکه گستران آریاسامانه، میتوانید فرم زیر را
          تکمیل نمایید.
        </p>
        <div class="flex flex-col w-full items-center">
          <div class="p-10 bg-blue-450/5 w-full">
            <Form
              class="w-full"
              :validation-schema="schema"
              :initial-values="initialValues"
              @submit="handleSubmit"
            >
              <div
                class="flex items-center justify-between [&>*]:w-full lg:[&>*]:w-[48%] flex-wrap"
              >
                <BaseInput name="name" placeholder="نام و نام خانوادگی" />
                <BaseInput name="number" placeholder="شماره موبایل" isNumber />
              </div>
              <BaseInputTextarea name="text" placeholder="متن پیام" />
              <div class="flex justify-end">
                <BaseButton
                  class="w-1/2"
                  isLean
                  size="full"
                  color="primary"
                  text="ارسال پیام"
                  :isLoading="loading"
                />
              </div>
            </Form>
          </div>
        </div>
      </section>
    <BaseModal :isShow="isSuccessModalShow" @close="closeModal" size="sm">
      <div
        class="flex flex-col w-full p-6 gap-4 text-black text-center text-lg font-bold"
      >
        <div>اطلاعات شما با موفقیت ثبت شد.</div>
        <div>
          <BaseButton
            @click="closeModal"
            isLean
            size="md"
            text="باشه"
            id="success_submit"
          />
        </div>
      </div>
    </BaseModal>
    <ProductMoreInformation :details="moreInfoData" class="mt-10">
      <template #title>
        <h3 class="text-xl lg:text-2xl font-bold text-center mb-10">
          {{ moreInfoData.title }}
        </h3>
      </template>
    </ProductMoreInformation>
  </div>
</template>
